interface TableSkeletonProps {
    /** Number of skeleton rows to render. */
    rows?: number;
    /** Number of columns in the parent table — drives the colspan/structure. */
    columns?: number;
}

/**
 * A shimmer-skeleton shaped like a data-table row. Drops into a
 * `.section-card` body in place of the loading spinner so the layout
 * doesn't jump when the data resolves. Honors prefers-reduced-motion via
 * the .skeleton primitive.
 */
export function TableSkeleton({ rows = 8, columns = 5 }: TableSkeletonProps): React.ReactElement {
    return (
        <div
            role="status"
            aria-label="Loading rows"
            style={{ padding: "var(--space-3) var(--space-4)" }}
        >
            {Array.from({ length: rows }, (_, i) => (
                <div
                    key={i}
                    style={{
                        display: "grid",
                        gridTemplateColumns: `repeat(${columns}, 1fr)`,
                        gap: "var(--space-3)",
                        padding: "var(--space-2) 0",
                        borderBottom: "var(--border-hairline) solid var(--color-border)",
                    }}
                >
                    {Array.from({ length: columns }, (_, c) => (
                        <span
                            key={c}
                            className="skeleton skeleton--text"
                            style={{ width: `${50 + ((i + c) % 4) * 12}%` }}
                        />
                    ))}
                </div>
            ))}
        </div>
    );
}
